import script from "./H2HeadingFix.vue?vue&type=script&setup=true&lang=js"
export * from "./H2HeadingFix.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__